import React, { Component } from 'react';
import Chord from './Chord';

class Tablature extends Component{
  render(){
    return(
      <div className='panel panel-default'>
        <Chord />
      </div>
    );
  }
}

export default Tablature;



// WEBPACK FOOTER //
// ./src/components/Tablature.js